const investTagLabelLang = {
	cies: {
		tag: 'invest.tag.label.cies',
		fr: 'CIES',
		en: 'CIES',
	},
	finansol: {
		tag: 'invest.tag.thematique.finansol',
		fr: 'FINANSOL',
		en: 'FINANSOL',
	},
	greenfin: {
		tag: 'invest.tag.thematique.greenfin',
		fr: 'GREENFIN',
		en: 'GREENFIN',
	},
	isr: {
		tag: 'invest.tag.thematique.isr',
		fr: 'ISR',
		en: 'ISR',
	},
};

export default investTagLabelLang;
